angular.module('core')
  .factory('customer', ['$rootScope', 'translationService', 'localeService', function ($rootScope, translationService, localeService) {

    var academicStandard = {
      academic_standard_name: 'ccss',
      academic_standard_title_in_reports: 'Common Core State Standards'
    };

    var getAcademicStandard = function () {
      return academicStandard;
    };

    var isAstDbl = function () {
        return academicStandard && academicStandard.academic_standard_name === 'dbl';
    };

    var isAstUk = function () {
      return academicStandard && academicStandard.academic_standard_name === 'uk_standards_2013';
    };

    var setAcademicStandard = function (standard) {
      try {
        academicStandard = standard;
      }
      catch(e) {
        console.log('Error: Could not set Academic Standard', e.message);
      }
    };

    $rootScope.$on('customerInfoSet', function(e, customer) {
      var standard = _.pick(customer, ['academic_standard_name', 'academic_standard_title_in_reports']);
      setAcademicStandard(standard);
      localeService.updateLocaleFromCustomer(customer);
      translationService.preloadDefaultTranslations();
    });

    return {
      getAcademicStandard: getAcademicStandard,
      isAstDbl: isAstDbl,
      isAstUk: isAstUk,
      setAcademicStandard: setAcademicStandard
    };
  }]);
